import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TerminosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-857">
      <section className="relative py-16 md:py-20 bg-brand-navy overflow-hidden" data-id="element-858">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/30 via-brand-navy to-brand-navy" data-id="element-859"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-860">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-861">
            <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-brand-gold transition-colors text-sm mb-8 group" data-id="element-862">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-863" />
              Volver al inicio
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight" data-id="element-864">
              Términos y Condiciones de{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-865">
                Uso
              </span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-20" data-id="element-866">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-gray-700 leading-relaxed space-y-8" data-id="element-867">
          <div data-id="element-868">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-869">
              1. ACEPTACIÓN DE LOS TÉRMINOS
            </h2>
            <p data-id="element-870">
              Al acceder, navegar, registrarse o utilizar el sitio web,
              aplicación móvil o cualquier plataforma digital oficial de
              Fundación REDORG (en adelante nombrados como la "Plataforma" y
              "REDORG" respectivamente), el usuario declara haber leído,
              entendido y aceptado íntegramente los presentes Términos y
              Condiciones, así como la Política de Privacidad vigente.
            </p>
            <p className="mt-2" data-id="element-871">
              Si el usuario no está de acuerdo con estos Términos, deberá
              abstenerse de utilizar la Plataforma.
            </p>
          </div>

          <div data-id="element-872">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-873">
              2. IDENTIFICACIÓN DEL TITULAR
            </h2>
            <p data-id="element-874">
              La Plataforma es operada por REDORG, entidad sin fines de lucro
              constituida conforme a las leyes de la República del Ecuador.
            </p>
          </div>

          <div data-id="element-875">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-876">
              3. USUARIOS
            </h2>
            <p className="mb-3" data-id="element-877">Pueden utilizar la Plataforma:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-878">
              <li data-id="element-879">Personas naturales mayores de 18 años</li>
              <li data-id="element-880">
                Menores de edad bajo la responsabilidad expresa de su padre,
                madre o representante legal, especialmente en el caso de
                escuelas deportivas
              </li>
            </ul>
            <p className="mt-2" data-id="element-881">
              El usuario es responsable de la veracidad de la información
              proporcionada durante su registro.
            </p>
          </div>

          <div data-id="element-882">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-883">
              4. SERVICIOS OFRECIDOS
            </h2>
            <p className="mb-3" data-id="element-884">La Plataforma permite, entre otros:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-885">
              <li data-id="element-886">
                Administración de organizaciones, aliados, socios y adherentes.
              </li>
              <li data-id="element-887">Administración y venta de productos y servicios.</li>
              <li data-id="element-888">
                Inscripción para eventos, capacitaciones, actividades u otros.
              </li>
              <li data-id="element-889">
                Pago de mensualidades, matrículas y otros valores relacionados
                con productos y servicios.
              </li>
              <li data-id="element-890">Acceso a contenido informativo, promocional y multimedia.</li>
              <li data-id="element-891">Otros productos y servicios.</li>
            </ul>
            <p className="mt-2" data-id="element-892">
              REDORG se reserva el derecho de modificar, suspender o eliminar
              servicios sin previo aviso.
            </p>
          </div>

          <div data-id="element-893">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-894">
              5. REGISTRO Y CUENTAS
            </h2>
            <p className="mb-3" data-id="element-895">
              Para acceder a ciertos servicios, el usuario deberá crear una
              cuenta proporcionando información veraz y actualizada.
            </p>
            <p className="mb-3" data-id="element-896">El usuario es responsable de:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-897">
              <li data-id="element-898">Mantener la confidencialidad de su usuario y contraseña.</li>
              <li data-id="element-899">Todas las actividades realizadas desde su cuenta.</li>
            </ul>
            <p className="mt-2" data-id="element-900">
              REDORG no será responsable por el uso no autorizado de cuentas por
              negligencia del usuario.
            </p>
          </div>

          <div data-id="element-901">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-902">
              6. CONDICIONES DE VENTA – PRODUCTOS Y SERVICIOS
            </h2>
            <ul className="list-disc ml-6 space-y-1" data-id="element-903">
              <li data-id="element-904">
                Los productos y servicios están sujetos a disponibilidad de
                stock.
              </li>
              <li data-id="element-905">
                Los precios incluyen los impuestos aplicables conforme a la ley
                ecuatoriana.
              </li>
              <li data-id="element-906">
                Las imágenes son referenciales; pueden existir variaciones
                mínimas.
              </li>
              <li data-id="element-907">
                Cambios o devoluciones solo se aceptarán por defectos de
                fabricación o falta de prestación de servicio, conforme a la
                política vigente.
              </li>
            </ul>
            <p className="mt-2" data-id="element-908">
              REDORG no se responsabiliza por retrasos atribuibles a terceros
              (courier, fuerza mayor, etc.).
            </p>
          </div>

          <div data-id="element-909">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-910">
              7. PAGOS Y TRANSACCIONES
            </h2>
            <ul className="list-disc ml-6 space-y-1" data-id="element-911">
              <li data-id="element-912">
                Todos los pagos se procesan a través de plataformas seguras de
                terceros.
              </li>
              <li data-id="element-913">REDORG no almacena información bancaria sensible.</li>
              <li data-id="element-914">
                El usuario autoriza el débito de los valores correspondientes a
                los productos y servicios adquiridos.
              </li>
            </ul>
            <p className="mt-2" data-id="element-915">
              Cualquier reclamo deberá realizarse dentro de los plazos
              establecidos por la ley.
            </p>
          </div>

          <div data-id="element-916">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-917">
              8. PROPIEDAD INTELECTUAL
            </h2>
            <p data-id="element-918">
              Todo el contenido de la Plataforma (logos, escudos, textos,
              imágenes, videos, diseños, marcas y software) es propiedad
              exclusiva de REDORG o de terceros autorizados.
            </p>
            <p className="mt-2" data-id="element-919">
              Queda prohibida su reproducción, distribución o uso comercial sin
              autorización expresa y por escrito.
            </p>
          </div>

          <div data-id="element-920">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-921">
              9. USO PROHIBIDO
            </h2>
            <p className="mb-3" data-id="element-922">El usuario se compromete a no:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-923">
              <li data-id="element-924">Utilizar la Plataforma con fines ilícitos.</li>
              <li data-id="element-925">Realizar fraudes o suplantación de identidad.</li>
              <li data-id="element-926">Introducir virus, malware o códigos dañinos.</li>
              <li data-id="element-927">Afectar el funcionamiento de la Plataforma.</li>
            </ul>
            <p className="mt-2" data-id="element-928">
              El incumplimiento podrá resultar en la suspensión o cancelación
              inmediata de la cuenta.
            </p>
          </div>

          <div data-id="element-929">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-930">
              10. RESPONSABILIDAD Y LIMITACIONES
            </h2>
            <p className="mb-3" data-id="element-931">REDORG no garantiza:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-932">
              <li data-id="element-933">Disponibilidad ininterrumpida de la Plataforma.</li>
              <li data-id="element-934">Ausencia total de errores técnicos.</li>
            </ul>
            <p className="mt-2" data-id="element-935">
              El uso de la Plataforma se realiza bajo responsabilidad exclusiva
              del usuario.
            </p>
          </div>

          <div data-id="element-936">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-937">
              11. PROTECCIÓN DE DATOS PERSONALES
            </h2>
            <p data-id="element-938">
              El tratamiento de los datos personales se rige por la Política de
              Privacidad de REDORG y la normativa vigente en Ecuador.
            </p>
          </div>

          <div data-id="element-939">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-940">
              12. VIGENCIA Y MODIFICACIONES
            </h2>
            <p data-id="element-941">REDORG podrá modificar estos Términos en cualquier momento.</p>
            <p className="mt-2" data-id="element-942">
              La vigencia de estos Términos y Condiciones de Uso es desde el 20
              de marzo de 2026 y permanecerá vigente hasta que exista una nueva
              versión que la reemplace.
            </p>
          </div>

          <div data-id="element-943">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-944">
              13. LEGISLACIÓN Y JURISDICCIÓN
            </h2>
            <p data-id="element-945">
              Estos Términos se rigen por las leyes de la República del Ecuador.
            </p>
            <p className="mt-2" data-id="element-946">
              Cualquier controversia será sometida a los jueces competentes de
              la ciudad de Guayaquil.
            </p>
          </div>

          <div data-id="element-947">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-948">
              14. CONTACTO
            </h2>
            <p data-id="element-949">
              Para consultas o reclamos, el usuario puede comunicarse a través
              de los canales oficiales de REDORG disponibles en la Plataforma.
            </p>
          </div>
        </motion.div>
      </section>
    </div>;
}